import { atom } from 'recoil';

export type IConfirmationAlert = {
	isShowing?: boolean;
	message?: string;
	title?: string;
	onConfirmFunc: () => void;
	onCancelFunc?: () => void;
	confirmButtonText?: string;
	cancelButtonText?: string;

};

export const confirmationAlertState = atom<IConfirmationAlert>({
	key: 'ConfirmationAlertAtom',
	default: {
		isShowing: false,
		message: '',
		title: '',
		onConfirmFunc: () => {},
		cancelButtonText: '',
		confirmButtonText: '',
	},
});
